import { Field } from "@components/common/Field";
import { Agency } from "@gen/agency/v1/agency_pb";
import { Caisse } from "@gen/caisse/v1/caisse_pb";
import { Role, User } from "@gen/user/v1/user_pb";

export const fields: (
  t: (s: string) => string,
  agencies: Agency[],
  caisses: Caisse[],
) => Field<User, keyof User>[] = (t, agencies, caisses) => [
  {
    key: "email",
    type: "text",
    label: t("email"),
    placeholder: "john.doe@example.com",
    creation: {
      enabled: true,
      order: 0,
      rules: {
        required: t("form.emailRequired"),
        pattern: {
          value: new RegExp("^[\\w.%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$"),
          message: t("form.emailInvalid"),
        },
      },
    },
    sortable: true,
    filterable: true,
  },
  {
    key: "firstName",
    type: "text",
    label: t("firstName"),
    placeholder: "John",
    creation: {
      enabled: true,
      order: 1,
      rules: {
        required: t("form.firstNameRequired"),
      },
    },
    sortable: true,
    filterable: true,
  },
  {
    key: "lastName",
    type: "text",
    label: t("lastName"),
    placeholder: "Doe",
    creation: {
      enabled: true,
      order: 2,
      rules: {
        required: t("form.lastNameRequired"),
      },
    },
    sortable: true,
    filterable: true,
  },
  {
    key: "role",
    type: "select-toggle",
    creation: {
      enabled: true,
      order: 4,
      rules: {
        required: true,
      },
      defaultValue: Role.TRAVEL_AGENT,
    },
    editable: true,
    display: (role) => {
      switch (role) {
        case Role.ADMIN:
          return t("user.role.admin");
        case Role.TRAVEL_AGENT:
          return t("user.role.travelAgent");
        case Role.CAISSE_ASSOCIATE:
          return t("user.role.caisseAssociate");
        case Role.USER:
          return t("user.role.user");
        default:
          return role?.toString();
      }
    },
    options: [
      {
        value: Role.TRAVEL_AGENT,
        label: t("user.role.travelAgent"),
      },
      {
        value: Role.CAISSE_ASSOCIATE,
        label: t("user.role.caisseAssociate"),
      },
    ],
    filterOptions: [
      {
        value: Role.ADMIN,
        label: t("user.role.admin"),
      },
      {
        value: Role.TRAVEL_AGENT,
        label: t("user.role.travelAgent"),
      },
      {
        value: Role.CAISSE_ASSOCIATE,
        label: t("user.role.caisseAssociate"),
      },
    ],
    sortable: true,
    filterable: true,
  },
  {
    key: "agencyId",
    type: "select",
    label: t("agency"),
    placeholder: "Sélectionnez l'agence",
    creation: {
      enabled: true,
      order: 5,
      rules: {
        required: t("form.agency.required"),
      },
    },
    editable: true,
    condition: (user) => !!user?.role && user.role === Role.TRAVEL_AGENT,
    options: agencies.map((a) => ({
      label: a.alias,
      value: a.id,
    })),
    filterable: true,
    search: true,
  },
  {
    key: "caisseIds",
    type: "select",
    label: t("caisses"),
    condition: (user) => !!user?.role && user.role === Role.CAISSE_ASSOCIATE,
    creation: {
      enabled: true,
      order: 6,
      rules: {
        required: t("form.caisses.required"),
      },
    },
    editable: true,
    multi: true,
    options: caisses.map((c) => ({
      label: c.name,
      value: c.id,
    })),
    filterable: true,
    search: true,
  },
];
